/* Hubs expandable maps */
import { Loader } from '@googlemaps/js-api-loader';
import { MarkerClusterer } from "@googlemaps/markerclusterer";

export function hubs_expandable_map() {

	( ( $ ) => {

		if ( $( '.block--hubs-expandable-map--map-wrapper' ).length <= 0 ) {
			return;
		}

		const loader = new Loader( {
			apiKey: window.COVE.google_maps_api_key,
			version: "weekly",
			libraries: [ 'maps', 'marker' ]
		} );
	
		let Gmap;
		const block = $( '.block--hubs-expandable-map' );

		loader.importLibrary( 'maps' ).then( async ( { Map } ) => {

			const { AdvancedMarkerElement } = await loader.importLibrary( 'marker' );

			Gmap = new Map( block.find( '.block--hubs-expandable-map--map-wrapper' )[0], {
				center: {
					lat: 33,
					lng: -98
				},
				zoom: 4,
				mapId: window.COVE.google_maps_map_style_id, // This one is coming from Google Cloud Styling
				mapTypeId: 'roadmap',
				disableDefaultUI: true,
				zoomControl: true,
				clickableIcons: false
			} );

			if ( block.data( 'community-categories' ) ) {
				$.ajax( {
					type: 'GET',
					url: `/wp-json/wp/v2/community?_fields=link,title,acf,_embedded,_links.wp:featuredmedia,_links.wp:term&community-category=${block.data( 'community-categories' )}&per_page=100&_embed=wp:featuredmedia,wp:term`,
					dataType: "json",
					success: ( response ) => {
						let clusteredMarkers = [];

						const Windi = new google.maps.InfoWindow( {
							shouldFocus: true,
							minWidth: 350
						} );

						response.forEach( ( community ) => {

							if ( community.acf.location ) {

								const svg_icon_parser = new DOMParser();

								const Marky = new AdvancedMarkerElement( {
									map: Gmap,
									title: community.title.rendered,
									content: svg_icon_parser.parseFromString( window.COVE.maps_advanced_marker_icon, 'image/svg+xml' ).documentElement,
									gmpClickable: true,
									position: {
										lat: community.acf.location.lat,
										lng: community.acf.location.lng
									}
								} );

								Marky.addListener( 'click', ( { domEvent, latLng } ) => {
									
									let community_tags = [];
									let community_pills = '';

									community._embedded['wp:term'].forEach( block => {
										block.forEach( term => {
											if ( 'community-category' == term.taxonomy ) {
												community_tags.push( term.name );
											}	
										} );
									} );

									if ( community_tags.length > 0 ) {
										community_pills = `<ul class="community-categories"><li>${community_tags.join( '</li><li>' )}</li></ul>`;
									}

									Windi.setContent( `
										<div class="card card-destination-map">
											<img 
												class="card-img-top" 
												decoding="async" 
												loading="lazy" 
												alt="${community._embedded['wp:featuredmedia'][0].alt_text}" 
												src="${community._embedded['wp:featuredmedia'][0].media_details.sizes.medium_large.source_url}" 
											>
											<div class="card-body">
												${community_pills}
												<h2 class="card-title">${community.title.rendered}</h2>
												<p class="card-text address">${community.acf.city}, ${community.acf.state}</p>
												<a class="card-link" href="${community.link}" rel="community">Learn more about ${community.title.rendered}</a>
											</div>
										</div>
									` );

									Windi.open( {
										anchor: Marky,
										map: Gmap
									} );
								} );

								clusteredMarkers.push( Marky );

							}
						} );

						/* -------------------------------------
						* Clustering
						* ---------------------------------- */

						const customRenderer = {
							// palette: interpolateRgb( "red", "blue" ),
							render: function ( { count, position }, stats ) {
								const svg_icon_parser = new DOMParser();

								// create svg url with fill color
								const svg = `
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
										<circle cx="24" cy="24" r="22" style="fill: #1F87D3; stroke: #FFFFFF; stroke-width: 1px;" />
										<text style="fill: #FFFFFF;" x="50%" y="50%" transform="translate(0 2)" font-family="Helvetica, sans-serif" font-size="16" dominant-baseline="middle" text-anchor="middle">${count}</text>
									</svg>
								`;

								// create marker using svg icon
								return new AdvancedMarkerElement( {
									position,
									content: svg_icon_parser.parseFromString( svg, 'image/svg+xml' ).documentElement,
									// adjust zIndex to be above other markers
									zIndex: Number( google.maps.Marker.MAX_ZINDEX ) + count,
								} );
							}
						};

						if ( clusteredMarkers.length > 0 ) {
							new MarkerClusterer( {
								renderer: customRenderer, 
								map: Gmap, 
								markers: clusteredMarkers
							} );
						}
					}
				} );
			}

			// Slide the whole block to top when clicking the browsing button
			block.find( '.block--hubs-expandable-map--content button' ).on( 'click', ( ev ) => {
				let nav_offset = 0;

				nav_offset += parseInt( $( "#wpadminbar" ).outerHeight() || 0 );

				if ( $( "#site-navigation" ).is( ':visible' ) ) {
					nav_offset += parseInt( $( "#site-navigation" ).outerHeight() || 0 );
				}
				
				if ( $( "#site-navigation" ).is( ':visible' ) ) {
					nav_offset += $( ".announcement-bar--top-bar" ).outerHeight() || 0;
				}

				if ( $( "#site-navigation" ).is( ':visible' ) ) {
					nav_offset += $( '#mobile-navigation' ).outerHeight() || 0;
				}

				$( window ).scrollTop( parseInt( block.offset().top ) - nav_offset );
			} );

		} );

	} )( window.jQuery );
	
}